import { render, staticRenderFns } from "./TermsUpdate.vue?vue&type=template&id=717dadc3&scoped=true&"
import script from "./TermsUpdate.vue?vue&type=script&lang=js&"
export * from "./TermsUpdate.vue?vue&type=script&lang=js&"
import style0 from "./TermsUpdate.vue?vue&type=style&index=0&id=717dadc3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717dadc3",
  null
  
)

component.options.__file = "TermsUpdate.vue"
export default component.exports